/*    
<summary>
   This is a common component that shows SVG image of no data.
   Developer:Pratiksha Sharma , Created Date:29-May-2025
</summary>
*/
import React from 'react';

const Nodata: React.FC = () => {
    return (
		<svg version="1.1" width="340px" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 500 500" >
			<style type="text/css">{`
				.st1{display:inline;fill:#FFFFFF;}
				.st2{opacity:0.4;}
				.st3{fill:#969696;}
				.st4{fill:#2E363D;}
				.st5{fill:var(--secondary-700);}
				.st6{fill:none;stroke:#121D30;stroke-width:0.75;stroke-miterlimit:10;}
				.st7{fill:#FFFFFF;}
				.st8{fill:var(--primary-500)}
				.st9{fill:#121D30;}
				.st10{fill:#D28A7B;}
				.st11{fill:#CB705D;}
				.st12{fill:var(--primary-800)}
				.st13{fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}
				.st14{fill:none;stroke:#121D30;stroke-miterlimit:10;}
                .st15{fill:var(--secondary-500);}
			`}</style>

<g id="OBJECTS">
	<g className="st2">
		<path className="st3" d="M61.8,416.6c0,0-51.6-31-32.7-72.5c11.1-24.4,59.2-15.3,54.2-55.9c-6.6-53.3-59.5-89.1-29-134.7
			c31.4-46.9,109.9,9,186.6-40.6c49.5-32,137.6-50,169.5,1c30.5,48.7-30.5,102.8,13.8,139.1c44.3,36.4,95,91.2-16.9,155.8
			c-5.6,3.2-10.5,8.8-16.5,8.8c-93.2,0-179.2-0.3-179.2-0.3"/>
		<path className="st3" d="M51.8,371.9c-11.6-1.9-0.7,32.2,15.8,27.8S61.5,373.4,51.8,371.9z"/>
		<path className="st3" d="M45.3,352.6c-6.6,2.4-4.4,16.8,5.4,13.8C60.6,363.3,51.8,350.3,45.3,352.6z"/>
		<path className="st3" d="M390.7,417.6c-103.9-0.3-179.2-0.3-179.2-0.3"/>
	</g>
	<g>
		<g>
			<path className="st4" d="M411.8,143.7c-1.9-0.4-3.7-1.3-5.2-2.5l0.5-0.6c1.4,1.1,3.1,1.9,4.9,2.3L411.8,143.7z M417.6,143.7l-0.2-0.8
				c1.8-0.4,3.4-1.2,4.9-2.3l0.5,0.6C421.2,142.4,419.4,143.3,417.6,143.7z M403,136.8c-0.9-1.8-1.3-3.6-1.3-5.6l0.8,0
				c0,1.8,0.4,3.6,1.2,5.3L403,136.8z M426.3,136.7l-0.7-0.3c0.8-1.6,1.2-3.4,1.2-5.3l0.6,0l0.2,0
				C427.6,133.1,427.2,135,426.3,136.7z M403.7,125.9l-0.7-0.3c0.8-1.7,2.1-3.3,3.6-4.5l0.5,0.6
				C405.7,122.8,404.5,124.2,403.7,125.9z M425.6,125.8c-0.8-1.6-2-3.1-3.4-4.2l0.5-0.6c1.5,1.2,2.8,2.7,3.6,4.5L425.6,125.8z
				 M411.9,119.3l-0.2-0.8c0.9-0.2,1.9-0.3,2.9-0.3h0c1,0,1.9,0.1,2.8,0.3l-0.2,0.8c-0.9-0.2-1.8-0.3-2.7-0.3h0
				C413.8,119,412.8,119.1,411.9,119.3z"/>
		</g>
		<g>
			<path className="st4" d="M47.6,308L47.6,308l-0.2,0l0-0.8l0.2,0h0c1.7,0,3.5-0.2,5.1-0.6l0.2,0.8C51.1,307.8,49.3,308,47.6,308z
				 M41.8,307.3c-1.8-0.4-3.6-1.1-5.2-1.9l0.3-0.7c1.6,0.8,3.3,1.4,5.1,1.8L41.8,307.3z M58.1,305.6l-0.3-0.7
				c1.6-0.8,3.2-1.7,4.6-2.8l0.5,0.6C61.4,303.8,59.8,304.8,58.1,305.6z M31.9,302.4c-1.4-1.2-2.7-2.5-3.9-4l0.6-0.5
				c1.1,1.4,2.4,2.7,3.8,3.9L31.9,302.4z M66.8,298.8l-0.6-0.5c1.1-1.4,2.1-2.9,2.9-4.5l0.7,0.3C69,295.7,68,297.3,66.8,298.8z
				 M25.2,293.6c-0.8-1.7-1.4-3.5-1.7-5.3l0.8-0.2c0.4,1.8,0.9,3.5,1.7,5.1L25.2,293.6z M71.6,288.8l-0.8-0.2
				c0.4-1.7,0.6-3.5,0.6-5.3h0.8C72.2,285.2,72,287,71.6,288.8z M23.7,282.9l-0.8,0c0-1.9,0.3-3.7,0.7-5.5l0.8,0.2
				C23.9,279.3,23.7,281,23.7,282.9z M71,278.8c-0.3-1.8-0.9-3.5-1.6-5.1l0.7-0.3c0.7,1.7,1.3,3.5,1.7,5.3L71,278.8z M26.3,272.5
				l-0.7-0.4c0.8-1.7,1.9-3.2,3.1-4.6l0.6,0.5C28.1,269.4,27.1,270.9,26.3,272.5z M66.7,269c-1.1-1.4-2.3-2.8-3.7-3.9l0.5-0.6
				c1.4,1.2,2.7,2.6,3.8,4.1L66.7,269z M33.1,264.3l-0.5-0.6c1.5-1.1,3.1-2.1,4.8-2.8l0.3,0.7C36.1,262.2,34.5,263.2,33.1,264.3z
				 M58.6,262.1c-1.6-0.8-3.3-1.5-5-1.9l0.2-0.8c1.8,0.5,3.5,1.1,5.2,2L58.6,262.1z M42.9,259.9l-0.2-0.8c1.6-0.3,3.2-0.5,4.9-0.5
				c0.2,0,0.5,0,0.7,0l0,0.8c-0.2,0-0.5,0-0.7,0C46,259.4,44.4,259.6,42.9,259.9z"/>
		</g>
		<g>
			<circle className="st4" cx="70.7" cy="297" r="7.4"/>
		</g>
		<g>
			<circle className="st4" cx="398.9" cy="282.4" r="5.5"/>
		</g>
		<g>
			<path className="st4" d="M409.6,121.7c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9s1.8-3.9,3.9-3.9
				C407.8,117.8,409.6,119.5,409.6,121.7z"/>
		</g>
		<g>
			<path className="st4" d="M209.9,117.8c0,3.2-2.6,5.9-5.9,5.9c-3.2,0-5.9-2.6-5.9-5.9c0-3.2,2.6-5.9,5.9-5.9
				C207.3,111.9,209.9,114.5,209.9,117.8z"/>
		</g>
		<g>
			<path className="st4" d="M214.6,135.8c-0.5,0-0.9,0-1.4-0.1l0.1-0.8c1.7,0.2,3.5,0,5.2-0.7l0.3,0.7
				C217.5,135.5,216,135.8,214.6,135.8z M208,133.5c-1.5-1.2-2.6-2.8-3.3-4.5l0.7-0.3c0.6,1.6,1.7,3.1,3.1,4.2L208,133.5z
				 M223.2,131.4l-0.6-0.5c1-1.4,1.7-3.1,1.8-4.9l0.8,0.1C225,128.1,224.3,129.9,223.2,131.4z M204.8,125.2H204
				c0-1.9,0.5-3.8,1.5-5.4l0.7,0.4C205.3,121.7,204.8,123.4,204.8,125.2z M223.4,121c-0.8-1.6-2-2.9-3.4-3.9l0.4-0.7
				c1.6,1.1,2.9,2.5,3.7,4.2L223.4,121z M209.9,116.6l-0.4-0.7c1.7-0.9,3.6-1.3,5.5-1.3l0,0.8C213.3,115.4,211.5,115.8,209.9,116.6z
				"/>
		</g>
		<g>
			<path className="st4" d="M411,303.4c-1.9-0.1-3.7-0.7-5.4-1.6l0.4-0.7c1.6,0.8,3.3,1.3,5.1,1.5L411,303.4z M416.5,302.6l-0.3-0.7
				c1.7-0.6,3.2-1.5,4.5-2.7l0.5,0.6C419.9,301,418.3,302,416.5,302.6z M401.3,298.2c-1.2-1.5-2-3.2-2.5-5l0.8-0.2
				c0.5,1.7,1.3,3.3,2.4,4.7L401.3,298.2z M424.6,295.2l-0.7-0.3c0.7-1.6,1.1-3.4,1.1-5.2h0.8C425.7,291.6,425.3,293.4,424.6,295.2z
				 M424.9,288.3c-0.2-1.8-0.7-3.5-1.6-5l0.7-0.4c0.9,1.6,1.5,3.4,1.7,5.3L424.9,288.3z M399.2,287.7l-0.8-0.1
				c0.3-1.9,0.9-3.6,2-5.3l0.7,0.4C400.1,284.3,399.5,286,399.2,287.7z M419.7,279.3c-1.4-1.1-3.1-1.8-4.8-2.2l0.2-0.8
				c1.8,0.4,3.6,1.2,5.1,2.4L419.7,279.3z M404.7,279l-0.4-0.6c1.6-1.1,3.3-1.8,5.2-2.1l0.1,0.8C407.9,277.3,406.2,278,404.7,279z"
				/>
		</g>
	</g>
	<g>
		<g>
			<path className="st5" d="M313.3,309.9l3.9,14.7l81.6,0.4c2.3,0,3.5,1.8,2.6,4l-36.2,86.2c-0.7,1.6-2.9,2.9-4.9,2.9l-133.8-0.6
				c-2,0-3.4-1.3-3.1-3l13.5-82.9l1.2-7.4l2.1-12.7c0.4-2.3,2.6-4.2,5-4.2l64.9,0.3C311.7,307.6,313,308.5,313.3,309.9z"/>
			<path className="st6" d="M245.2,307.3l64.9,0.3c1.6,0,2.9,0.9,3.2,2.3l3.9,14.7l80.1,0.4"/>
			<g>
				
					<rect x="233.3" y="281.3" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 584.9944 623.366)" className="st7" width="118.4" height="60.7"/>
				<line className="st6" x1="244" y1="281.3" x2="328.3" y2="281.3"/>
			</g>
			<path className="st15" d="M283,306.5l6.8,13h69.6c2,0,3.6,1.6,3.6,3.6v91.4c0,2-1.6,3.6-3.6,3.6H225.9c-2,0-3.6-1.6-3.6-3.6v-88.2
				v-6.8v-11.3c0-2,1.6-3.6,3.6-3.6h53.9C281.1,304.5,282.4,305.3,283,306.5z"/>
			<path className="st6" d="M225.9,304.5h53.9c1.3,0,2.6,0.8,3.2,1.9l6.8,13h69.6"/>
			<g>
				<circle className="st9" cx="354.2" cy="322.9" r="19.1"/>
				<path className="st7" d="M362.4,330l-7.1-7.1l7.1-7.1c0.3-0.3,0.3-0.8,0-1c-0.3-0.3-0.8-0.3-1,0l-7.1,7.1l-7.1-7.1
					c-0.3-0.3-0.8-0.3-1,0c-0.3,0.3-0.3,0.8,0,1l7.1,7.1l-7.1,7.1c-0.3,0.3-0.3,0.8,0,1c0.3,0.3,0.8,0.3,1,0l7.1-7.1l7.1,7.1
					c0.3,0.3,0.8,0.3,1,0C362.7,330.7,362.7,330.3,362.4,330z"/>
			</g>
			<g>
				<path className="st6" d="M277.2,387.2c11.7-15.9,26.5-9.4,30.3,0"/>
				<g>
					<path className="st9" d="M274.7,353.9c0,4.1-1.9,7.5-4.1,7.5c-2.3,0-4.1-3.4-4.1-7.5c0-4.1,1.9-7.5,4.1-7.5
						C272.8,346.4,274.7,349.8,274.7,353.9z"/>
					<path className="st9" d="M318.2,353.9c0,4.1-1.9,7.5-4.1,7.5c-2.3,0-4.1-3.4-4.1-7.5c0-4.1,1.9-7.5,4.1-7.5
						C316.3,346.4,318.2,349.8,318.2,353.9z"/>
				</g>
			</g>
		</g>
		<g>
			<g>
				<g>
					<path className="st9" d="M145.4,135.6c0,0,8-11.7,18-5.9c12.5,7.3-2.6,24.7,6.7,29.7c9.3,5,18.9,5.4,21.5,19.3
						c3.5,18.2-29.4,43.7-57.2,27.6s-17.9-46.5-4.9-52.5C145.2,146.6,145.4,135.6,145.4,135.6z"/>
					<path className="st10" d="M150.8,163v16c0,2.1-0.8,4-2.2,5.3c-1.4,1.4-3.2,2.2-5.3,2.2c-4.2,0-7.5-3.4-7.5-7.5v-16H150.8z"/>
					<g>
						<path className="st10" d="M124.3,158.1c0.6,3,3.6,5,6.7,4.4c3-0.6,5-3.6,4.4-6.7c-0.6-3-3.6-5-6.7-4.4
							C125.7,152.1,123.7,155,124.3,158.1z"/>
						<line className="st6" x1="125.9" y1="156" x2="130.3" y2="159"/>
					</g>
					<g>
						<path className="st10" d="M156.2,157c0.6,3,3.6,5,6.7,4.4c3-0.6,5-3.6,4.4-6.7c-0.6-3-3.6-5-6.7-4.4
							C157.6,150.9,155.6,153.9,156.2,157z"/>
						<path className="st9" d="M161.2,155.8c0,0,3.2-3.5,2.1-11.9h-4.5L161.2,155.8z"/>
						<line className="st6" x1="160.8" y1="158.3" x2="165.2" y2="154.1"/>
					</g>
					<path className="st10" d="M147.1,133.8c8.1,0,14.7,6.6,14.7,14.7v12c0,0.3,0,0.6-0.1,0.9c-0.2,1.4-0.9,2.7-2.1,3.7l-5.9,4.9
						c-1.8,1.5-4.3,1.8-6.4,0.7l-11.6-5.8c-2-1-3.2-3.1-3.2-5.3v-11.2C132.4,140.4,139,133.8,147.1,133.8L147.1,133.8z"/>
					<path className="st6" d="M140.2,167.1l6.7,3.4c1.1,0.6,2.4,0.9,3.7,0.9h0.5"/>
					<polyline className="st6" points="149.4,133.8 153.1,159.5 148.5,159.5 					"/>
					<path className="st11" d="M161.8,152.4v7.5c-0.2,0-0.4,0-0.5,0c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8
						C161.4,152.4,161.6,152.4,161.8,152.4z"/>
					<path className="st11" d="M143.9,156.2c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8
						C142.2,152.4,143.9,154.1,143.9,156.2z"/>
					<path className="st9" d="M132.4,147.1v9.5c0,0,3.8-3.4,3.7-9.9L132.4,147.1z"/>
					<path className="st9" d="M166,131.8c-10-5.8-20.6,3.8-20.6,3.8s5.1,11-15.8,18.2c-3.4,1.2-7.8,7-9.8,10.3c0,0,4.6-13.2,6-21.8
						c1.5-8.6,9.1-7.2,9.1-7.2s4.6-11.3,17.4-11.2C161,123.9,166,131.8,166,131.8z"/>
					<g>
						<path className="st9" d="M158.8,153.1c0,1.3-0.6,2.4-1.3,2.4c-0.7,0-1.3-1.1-1.3-2.4c0-1.1,0.4-2,0.9-2.3h0l1.6,1.4
							C158.7,152.6,158.8,152.8,158.8,153.1z"/>
						<path className="st9" d="M145,153.1c0,1.3-0.6,2.4-1.3,2.4c-0.7,0-1.3-1.1-1.3-2.4c0-0.4,0.1-0.7,0.1-1.1l1.8-1
							C144.7,151.5,145,152.3,145,153.1z"/>
					</g>
					<path className="st9" d="M156,142.7c1.8-1.2,3-0.9,2.7,1.6L156,142.7z"/>
					<path className="st9" d="M141.2,144.3c-0.4-2.1,0.3-3.1,2.5-1.9L141.2,144.3z"/>
				</g>
				<path className="st6" d="M147.1,164.2c2-2.7,4.5-1.6,5.1,0"/>
			</g>
			<path className="st10" d="M175.2,232.7L175.2,232.7c3.5-1.8,4.9-6.1,3.1-9.7l-16.5-33c-1.8-3.5-6.1-4.9-9.7-3.1l0,0
				c-3.5,1.8-4.9,6.1-3.1,9.7l16.2,31.7c1.3,2.5,3.8,4.4,6.6,4.8C172.9,233.3,174.1,233.2,175.2,232.7z"/>
			<path className="st10" d="M107.8,239.2L107.8,239.2c-3.8-1-6.2-4.9-5.2-8.7l8.7-35.8c1-3.8,4.9-6.2,8.7-5.2l0,0
				c3.8,1,6.2,4.9,5.2,8.7l-8.6,34.5c-0.7,2.8-2.7,5.1-5.3,6.2C110.2,239.3,109,239.5,107.8,239.2z"/>
			<g>
				<polygon className="st12" points="174.9,204.2 161.2,203.3 146.7,208 161.2,208.6 				"/>
				<path className="st8" d="M170.4,191.4l2.3,18l-21.7,3l3.2-32.3l5.9,0.8C165.5,181.7,169.7,185.9,170.4,191.4z"/>
				<polygon className="st7" points="174.9,204.2 161.2,208.6 146.7,208 149.5,216.1 162.2,215.5 175.7,211.2 				"/>
			</g>
			<path className="st8" d="M159.4,237.3h-28.7l-18.4-35.8c-3-5.9-0.5-13.1,5.5-15.8l19-8.5l17.3,2.9c6,1,10.2,6.5,9.6,12.5L159.4,237.3
				z"/>
			<polygon className="st8" points="151.7,190.1 153.8,176 129.7,173.7 131.9,190.1 			"/>
			<g>
				<path className="st7" d="M132.4,184.1c3.6,4.6,7.9,7.2,12.1,7.2c3.8,0,7-2.2,8.8-5.9c-0.1,1.7-0.2,3.7-0.4,5.7
					c-0.7,7.5-2.2,12.6-4.2,14.6c-0.7,0.7-1.4,1-2.1,1c-0.3,0-0.7-0.1-1-0.2c-3.6-1.1-7.2-6.1-10.4-14.3
					C134,189.3,133.1,186.4,132.4,184.1 M130.6,180c0,0,5.5,24.3,14.8,27.2c0.4,0.1,0.9,0.2,1.3,0.2c8,0,7.5-27.4,7.5-27.4
					c-1,6.8-4.9,10.5-9.7,10.5C140,190.6,134.8,187.3,130.6,180L130.6,180z"/>
			</g>
			<g>
				<polygon className="st10" points="165.8,404.1 180.2,404.1 174.3,359.4 159.9,359.4 				"/>
				<polygon className="st7" points="164.4,404 180.7,404 178,382.8 161.9,384 				"/>
				<g>
					<path className="st9" d="M163.1,417.3H200l-1-3.3c-0.3-1.1-0.8-2.1-1.4-3c-1.3-1.9-3.2-3.4-5.4-4.2l-1-0.4c-1-0.3-1.9-0.8-2.8-1.4
						c-0.7-0.5-1.4-1-2-1.6c-1.3-1.3-2.4-2.9-3.1-4.7h-20.8L163,411L163.1,417.3z"/>
					<line className="st6" x1="177.3" y1="400.9" x2="184.6" y2="400.9"/>
					<line className="st6" x1="179.2" y1="403.5" x2="186.5" y2="403.5"/>
					<g>
						<path className="st6" d="M170,408.4c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9
							C170.5,407.5,170.1,407.9,170,408.4z"/>
						<path className="st6" d="M174.4,408.4c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9
							C174.9,407.5,174.5,407.9,174.4,408.4z"/>
					</g>
					<path className="st7" d="M163.1,417.3H200l-1-3.3c-0.3-1.1-0.8-2.1-1.4-3H163L163.1,417.3z"/>
					<line className="st6" x1="162.9" y1="414.2" x2="186.1" y2="414.2"/>
					<path className="st7" d="M179.3,417.3H200l-1-3.3c-0.3-1.1-0.8-2.1-1.4-3c-1.3-1.9-3.2-3.4-5.4-4.2l-1-0.4c-1-0.3-1.9-0.8-2.8-1.4
						C183.7,407.4,180.1,411.9,179.3,417.3z"/>
					<path className="st9" d="M183.4,398.8l0.5-1.8c0.3-1.3-0.6-2.5-1.9-2.5h-1.9c-1.5,0-2.8,0.7-3.7,2l-1.6,2.4H183.4z"/>
				</g>
			</g>
			<g>
				<polygon className="st9" points="122.9,230.2 162.7,228.1 159.2,238.2 126,237.8 				"/>
				<path className="st9" d="M159.2,238.2c0,0,13.7,12.6,14.5,35.2h-61.1c0-21.2,13.4-35.5,13.4-35.5L159.2,238.2z"/>
				<path className="st13" d="M124.1,246.6h9.6c0,0-4.7,10.9-14.2,11.6"/>
				<path className="st13" d="M165.8,246.6h-5.3c0,0,2,10.3,10.6,11.6"/>
				<path className="st13" d="M147.9,238.8l-0.9,16.7c0,0-3.1-1.6-2.4-7.2"/>
				<rect x="128" y="236.4" className="st9" width="8.7" height="3.5"/>
				<rect x="154.8" y="236.4" className="st9" width="3" height="3.5"/>
				<rect x="139.1" y="236.4" className="st9" width="13.7" height="3.5"/>
				<rect x="144.4" y="235.7" className="st7" width="5.9" height="4.8"/>
			</g>
			<g>
				<polygon className="st10" points="109.8,404.1 124.2,404.7 131.6,356.2 117.2,355.5 				"/>
				<polygon className="st7" points="108.9,404 125.2,404.8 128,382.7 111.8,383.6 				"/>
				<g>
					<path className="st9" d="M105.8,417.3h36.9l-0.3-3.3c-0.1-1.1-0.4-2.1-0.8-3c-0.9-1.9-2.5-3.4-4.6-4.2l-0.9-0.4
						c-0.9-0.3-1.7-0.8-2.5-1.4c-0.6-0.5-1.2-1-1.7-1.6c-1.1-1.3-1.8-2.9-2.2-4.7h-20.8l-2,12.2L105.8,417.3z"/>
					<line className="st6" x1="123.2" y1="400.9" x2="130.5" y2="400.9"/>
					<line className="st6" x1="124.5" y1="403.5" x2="131.8" y2="403.5"/>
					<g>
						<path className="st6" d="M114.4,408.4c-0.1,0.5,0.2,0.9,0.7,0.9c0.5,0,1-0.4,1.1-0.9c0.1-0.5-0.2-0.9-0.7-0.9
							C115,407.5,114.6,407.9,114.4,408.4z"/>
						<path className="st6" d="M118.8,408.4c-0.1,0.5,0.2,0.9,0.7,0.9s1-0.4,1.1-0.9c0.1-0.5-0.2-0.9-0.7-0.9
							C119.5,407.5,119,407.9,118.8,408.4z"/>
					</g>
					<path className="st7" d="M105.8,417.3h36.9l-0.3-3.3c-0.1-1.1-0.4-2.1-0.8-3h-34.7L105.8,417.3z"/>
					<line className="st6" x1="129.7" y1="414.2" x2="106.5" y2="414.2"/>
					<path className="st7" d="M122,417.3h20.7l-0.3-3.3c-0.1-1.1-0.4-2.1-0.8-3c-0.9-1.9-2.5-3.4-4.6-4.2l-0.9-0.4
						c-0.9-0.3-1.7-0.8-2.5-1.4C128.3,407.4,123.9,411.9,122,417.3z"/>
					<path className="st9" d="M129.7,398.8l0.8-1.8c0.6-1.3-0.1-2.5-1.4-2.5h-1.9c-1.5,0-3,0.7-4.1,2l-2.1,2.4H129.7z"/>
				</g>
			</g>
			<polygon className="st9" points="144.5,272.2 153.2,378.1 183.5,378.1 173.6,272.7 			"/>
			<polygon className="st9" points="117.4,320.7 106.8,378.1 137,378.1 146.5,321.2 			"/>
			<path className="st9" d="M117.4,320.7c0,0-4.8-31.4-4.8-47.6h30.2l3.6,48L117.4,320.7z"/>
			<g>
				<path className="st8" d="M108.2,196.9l-3.1,15.8l21.5,4.1l0.4-35.1l-10.1,4.3C112.4,188,109.1,192,108.2,196.9z"/>
				<polygon className="st7" points="103.1,207.4 116.7,210.2 126.7,211.5 123.6,219.4 102,214.4 				"/>
			</g>
			<path className="st8" d="M159.6,195.9c10.2,15.2,9.7,22.4-2.9,28L159.6,195.9z"/>
			<polyline className="st6" points="166.8,208.6 161.1,198.2 163.7,192.6 			"/>
			<g>
				<g>
					<path className="st10" d="M85.9,228.4c-6-3.1-13-2.9-13-2.9l2.1-12.3c11.8,1.4,15.6,6.5,17.2,9.7L85.9,228.4z"/>
					<path className="st10" d="M72.9,225.5c0,0-5.8-2.4-8.4-7l2.7-7c0,0,3.8,3.9,7.3,4.4c0,0-4.6-3.6-5.5-6.8l2.1-0.7
						c0,0,3.4,4.2,8.6,6.1L72.9,225.5z"/>
				</g>
				<path className="st6" d="M65.2,216.7c0,0,3.8,3.9,7.3,5.8"/>
				<path className="st6" d="M66.2,214c0,0,3.2,3.7,7.6,5.6"/>
			</g>
			<path className="st10" d="M116.9,230.5l-29.2-10l-4.4,5.2c5,5.7,10.6,10.7,16.8,14.5C107.4,244.6,116.9,239.2,116.9,230.5
				L116.9,230.5z"/>
			<polyline className="st13" points="157.9,378.1 147.3,269.9 142,269.9 			"/>
			<path className="st13" d="M128,239.9c0,0-12.8,17.9-10.2,37.5c2.6,19.6,5,43.4,5,43.4L111,378.1"/>
			<line className="st6" x1="113.2" y1="228.6" x2="103.9" y2="226"/>
			<g>
				<g>
					<path className="st10" d="M194.1,217.2c5.2-4.4,12.1-5.7,12.1-5.7l-4.8-11.5c-11.2,4-13.7,9.8-14.6,13.3L194.1,217.2z"/>
					<path className="st10" d="M206.1,211.5c0,0,5.1-3.6,6.6-8.8l-4.2-6.2c0,0-2.9,4.7-6.1,6c0,0,3.7-4.6,3.8-7.9l-2.2-0.2
						c0,0-2.4,4.9-7,7.8L206.1,211.5z"/>
				</g>
				<path className="st6" d="M211.6,201.2c0,0-2.9,4.7-5.8,7.3"/>
				<path className="st6" d="M210,198.7c0,0-2.3,4.4-6.1,7.2"/>
			</g>
			<path className="st10" d="M164.4,226.2l26.2-16.3l5.5,4c-3.6,6.7-7.9,12.8-13.1,17.9C176.8,237.8,166.3,234.7,164.4,226.2
				L164.4,226.2z"/>
			<line className="st6" x1="167.6" y1="223.6" x2="176" y2="218.9"/>
			<line className="st6" x1="111.2" y1="387.8" x2="127.5" y2="387.1"/>
			<line className="st6" x1="161.9" y1="387.4" x2="178.5" y2="386.1"/>
		</g>
		<line className="st14" x1="33.9" y1="417.6" x2="466.8" y2="417.6"/>
		<g>
			<g>
				<g>
					<path className="st7" d="M300.8,170.8c17.6,3.8,35.1,7.7,52.7,11.5c-8-23.9,21.9-39.6,13.9-63.5c-17.6-3.8-35.1-7.7-52.7-11.5
						C322.7,131.3,292.8,146.9,300.8,170.8z"/>
				</g>
				<g>
					<path className="st6" d="M361,149.5c5.3-9.5,10.2-19.1,6.3-30.7c-17.6-3.8-35.1-7.7-52.7-11.5"/>
					<path className="st6" d="M300.8,170.8c17.6,3.8,35.1,7.7,52.7,11.5c-2.6-7.6-1.3-14.4,1.4-20.9"/>
				</g>
			</g>
			<g>
				<g>
					<path className="st7" d="M264.6,246.3c15.5-9.1,31-18.3,46.4-27.4c-22.2-12.1-10.9-43.9-33.1-56c-15.5,9.1-31,18.3-46.4,27.4
						C253.7,202.4,242.4,234.2,264.6,246.3z"/>
				</g>
				<g>
					<path className="st6" d="M264.6,246.3c15.5-9.1,31-18.3,46.4-27.4c-10.1-5.5-13.2-15-15.8-24.9"/>
					<path className="st6" d="M258.9,174.2c-9.1,5.4-18.2,10.8-27.3,16.1c11.6,6.3,14.1,18.1,16.9,29.7"/>
				</g>
			</g>
			<g>
				<g>
					<path className="st7" d="M359.4,272c-15.5-9.1-31-18.3-46.4-27.4c22.2-12.1,10.9-43.9,33.1-56c15.5,9.1,31,18.3,46.4,27.4
						C370.3,228.1,381.6,260,359.4,272z"/>
				</g>
				<g>
					<path className="st6" d="M376.9,240.2c-3.2,12.2-5.1,25.1-17.5,31.8c-10.3-6.1-20.6-12.1-30.8-18.2"/>
					<path className="st6" d="M330.9,211.3c2.5-9.1,5.9-17.6,15.2-22.7c8.3,4.9,16.6,9.8,24.9,14.7"/>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>

    );
}

export default Nodata;